import React, { useEffect, createElement } from 'react';
import { NavbarV2 } from './components/NavbarV2';
import { Hero } from './components/Hero';
import { PartnerLogos } from './components/PartnerLogos';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { SystemsWeInstall } from './components/SystemsWeInstall';
import { Advantages } from './components/Advantages';
import { Testimonial } from './components/Testimonial';
import { News } from './components/News';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
import { FooterV2 } from './components/FooterV2';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
// Existing pages
import { KnowledgeHub } from './pages/KnowledgeHub';
import { Compliance } from './pages/pillars/Compliance';
import { MaintenanceGuide } from './pages/pillars/MaintenanceGuide';
import { InstallationGuide } from './pages/pillars/InstallationGuide';
import { RepairsEfficiency } from './pages/pillars/RepairsEfficiency';
import { EcoVentilation } from './pages/pillars/EcoVentilation';
import { SystemGuides } from './pages/pillars/SystemGuides';
import { HomeV2 } from './pages/HomeV2';
// New pages
import { ServicesOverview } from './pages/ServicesOverview';
import { WhyAccuTemp } from './pages/WhyAccuTemp';
import { CaseStudies } from './pages/CaseStudies';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Installation } from './pages/services/Installation';
import { Maintenance } from './pages/services/Maintenance';
import { TM44 } from './pages/services/TM44';
import { Ventilation } from './pages/services/Ventilation';
import { Ducted } from './pages/services/Ducted';
import { Cassette } from './pages/services/Cassette';
import { WallMounted } from './pages/services/WallMounted';
import { FormulaOne } from './pages/case-studies/FormulaOne';
import { Subway } from './pages/case-studies/Subway';
import { ProcessCooling } from './pages/case-studies/ProcessCooling';
import { Sitemap } from './pages/Sitemap';
import { LocationLandingPage } from './pages/LocationLandingPage';
import { AreasWeCover } from './pages/AreasWeCover';
function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}
function MetaDescription() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Commercial AC installation & maintenance';
  }, []);
  return null;
}
function HomePage() {
  return <main id="main-content" data-id="element-0">
      <Hero data-id="element-1" />
      <PartnerLogos data-id="element-2" />
      <Stats data-id="element-3" />
      <Services data-id="element-4" />
      <SystemsWeInstall data-id="element-5" />
      <Advantages data-id="element-6" />
      <Testimonial data-id="element-7" />
      <News data-id="element-8" />
      <Newsletter data-id="element-9" />
    </main>;
}
function AppLayout() {
  const location = useLocation();
  return <div className="min-h-screen bg-white font-sans selection:bg-accent/20 selection:text-primary-dark" data-id="element-10">
      <ScrollToTop data-id="element-11" />
      <MetaDescription data-id="element-12" />
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-accent focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:text-sm focus:font-medium" data-id="element-13">
        Skip to main content
      </a>
      <NavbarV2 data-id="element-14" />
      <Routes data-id="element-15">
        <Route path="/" element={<HomeV2 data-id="element-17" />} data-id="element-16" />

        {/* Core Pages */}
        <Route path="/services" element={<ServicesOverview data-id="element-19" />} data-id="element-18" />
        <Route path="/why-accutemp" element={<WhyAccuTemp data-id="element-21" />} data-id="element-20" />
        <Route path="/case-studies" element={<CaseStudies data-id="element-23" />} data-id="element-22" />
        <Route path="/about" element={<About data-id="element-25" />} data-id="element-24" />
        <Route path="/contact" element={<Contact data-id="element-27" />} data-id="element-26" />

        {/* Service areas */}
        <Route path="/areas-we-cover" element={<AreasWeCover data-id="element-29" />} data-id="element-28" />
        <Route path="/locations/:slug" element={<LocationLandingPage data-id="element-31" />} data-id="element-30" />

        {/* Service Detail Pages */}
        <Route path="/services/installation" element={<Installation data-id="element-33" />} data-id="element-32" />
        <Route path="/services/maintenance" element={<Maintenance data-id="element-35" />} data-id="element-34" />
        <Route path="/services/tm44" element={<TM44 data-id="element-37" />} data-id="element-36" />
        <Route path="/services/ventilation" element={<Ventilation data-id="element-39" />} data-id="element-38" />
        <Route path="/services/ducted" element={<Ducted data-id="element-41" />} data-id="element-40" />
        <Route path="/services/cassette" element={<Cassette data-id="element-43" />} data-id="element-42" />
        <Route path="/services/wall-mounted" element={<WallMounted data-id="element-45" />} data-id="element-44" />

        {/* Case Studies */}
        <Route path="/case-studies/formula-one" element={<FormulaOne data-id="element-47" />} data-id="element-46" />
        <Route path="/case-studies/subway" element={<Subway data-id="element-49" />} data-id="element-48" />
        <Route path="/case-studies/process-cooling" element={<ProcessCooling data-id="element-51" />} data-id="element-50" />

        {/* Resources / Knowledge Hub */}
        <Route path="/knowledge-hub" element={<KnowledgeHub data-id="element-53" />} data-id="element-52" />
        <Route path="/knowledge-hub/compliance" element={<Compliance data-id="element-55" />} data-id="element-54" />
        <Route path="/knowledge-hub/maintenance-guide" element={<MaintenanceGuide data-id="element-57" />} data-id="element-56" />
        <Route path="/knowledge-hub/installation-guide" element={<InstallationGuide data-id="element-59" />} data-id="element-58" />
        <Route path="/knowledge-hub/repairs-efficiency" element={<RepairsEfficiency data-id="element-61" />} data-id="element-60" />
        <Route path="/knowledge-hub/eco-ventilation" element={<EcoVentilation data-id="element-63" />} data-id="element-62" />
        <Route path="/knowledge-hub/system-guides" element={<SystemGuides data-id="element-65" />} data-id="element-64" />
        <Route path="/sitemap" element={<Sitemap data-id="element-67" />} data-id="element-66" />
      </Routes>
      <FooterV2 data-id="element-68" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-69">
      <AppLayout data-id="element-70" />
    </BrowserRouter>;
}